<template>
  <div>
    <div class="w-imbee-footer">
      <span>
        Powered by
        <a href="https://imbee.me/" target="_blank">Imbee</a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.w-imbee-footer,
.w-imbee-footer a {
  transition: color 0.3s ease;
}

.w-imbee-footer {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 999;
  text-align: center;
  font-size: 12px;
  padding: 8px 4px;
  box-shadow: 0 -3px 8px -1px rgba(120, 120, 120, 0.12);
  background-color: #fff;
  border-radius: 0 0 12px 12px;
  color: rgba(120, 120, 120, 0.6);
}

.w-imbee-footer a {
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  color: rgba(92, 92, 92, 0.7);
}

.w-imbee-footer a:hover {
  color: rgb(80, 80, 80);
}
</style>


// WEBPACK FOOTER //
// Footer.vue?7a0564dc